import { RetriedImage } from "@components/RetriedImage";

export const PastEventCard = (props: {
  id: number;
  photoSRC?: string;
  disableNavigation?: boolean;
  title: string;
  location: string;
  registered?: boolean;
}) => {
  return (
    <a
      class="text-primary h-[420px]"
      href={!props.disableNavigation ? `/past-event/?eventId=${props.id}` : "#"}
    >
      <div
        class="h-full border border-light-gray text-left rounded-xl px-6 py-8 relative flex flex-col justify-center hover:drop-shadow-lg transition duration-500 ease-in-out"
        classList={{
          "bg-white": !props.registered,
          "bg-primary bg-opacity-20": props.registered,
        }}
      >
        <div class="absolute top-2 left-4 px-3 py-2 bg-white rounded-3xl border-2 border-primary">
          {props.location}
        </div>
        <RetriedImage
          src={props.photoSRC?.trim()}
          alt="Image of event"
          class="rounded-lg place-self-center w-full h-full overflow-hidden object-cover"
        />
        <h2 class="mt-4 mb-8 text-lg text-primary font-semibold">
          {props.title}
        </h2>
        <div class="absolute bottom-4 right-4 text-right">
          <p class="text-text-secondary">{props.location}</p>
        </div>
        <div class="absolute bottom-[-20px] left-4 px-3 py-2 bg-white rounded-3xl border-2 text-xs border-primary">
          Compete for fun-choose your date and time!
        </div>
      </div>
    </a>
  );
};

export default PastEventCard;
